module.exports = __webpack_public_path__ + "img/Icon-Emotiva-2020.71905d06.svg";